module.exports = __webpack_public_path__ + "assets/img/FinancialTerminal.47f3e32c.png";